import { ListItemText, TextField, Grid } from "@mui/material"

export const SelectLabel = ({
    label,
    value,
    onValueChange,
    options,
    disabled,
    placeholder
}: {
    label?: string,
    value?: boolean | null,
    options: string[],
    onValueChange?: (event: string | boolean | null) => void,
    disabled?: boolean,
    placeholder?: string
}) => {
    return (
        <Grid container spacing={0} sx={{ mb: 2 }}>
            {label && (
                <Grid size={2}>
                    <ListItemText primary={label} primaryTypographyProps={{ fontWeight: 600, fontSize: 14 }} />
                </Grid>
            )}
            <Grid size={10}>
                <TextField
                    select
                    autoComplete='off'
                    sx={{ width: "100%" }}
                    inputProps={{ style: { fontSize: 14 } }}
                    InputLabelProps={{ style: { fontSize: 14 } }}
                    variant="standard"
                    placeholder={placeholder || ""}
                    value={value || ""}
                    disabled={disabled}
                    onChange={(event) => {
                        const selectedOption = options.find(option => option === event.target.value);
                        onValueChange && onValueChange(selectedOption || null);
                    }}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option value={""}>
                        {` `}
                    </option>
                    {options.map((option, index) => (
                        <option key={index} value={option}>
                            {option}
                        </option>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    )
}